import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  Input,
  OnChanges,
  Output,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import {
  faDiamondExclamation,
  faPlus,
  faTrash,
} from '@fortawesome/pro-solid-svg-icons';
import { BannerService } from '@terminus-ui/banner';
import { Button } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';

@Component({
  selector: 'lib-manual-add',
  imports: [
    Button,
    CommonModule,
    FormsModule,
    FaIconComponent,
    InputTextModule,
  ],
  templateUrl: './manual-add.component.html',
  styleUrl: './manual-add.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ManualAddComponent implements OnChanges {
  @Input() columns: {
    name: string;
    label: string;
    validator: (value: any) => boolean;
  }[];
  @Output() rows = new EventEmitter<any[]>();
  private bannerService = inject(BannerService);

  newRow = {};
  internalRows: any[] = [];
  faPlus = faPlus;
  faTrash = faTrash;
  protected readonly faDiamondExclamation = faDiamondExclamation;

  initNewRow() {
    if (!this.columns) {
      return;
    }

    this.columns.forEach((column) => {
      this.newRow[column.name] = '';
    });
  }

  ngOnChanges() {
    this.initNewRow();
  }

  addRow() {
    for (let i = 0; i < this.columns.length; i++) {
      const column = this.columns[i];
      if (
        this.columns[i].validator &&
        !this.columns[i].validator(this.newRow[column.name])
      ) {
        this.bannerService.pushBanner({
          isClosable: true,
          isFloating: false,
          title: `Invalid ${column.label}`,
          type: 'error',
          enableAutoDismissWithDuration: 1000,
        });
        return;
      }
      this.newRow[column.name] = this.newRow[column.name].trim();
    }
    this.internalRows.push(this.newRow);
    this.newRow = {};
    this.initNewRow();
    this.rows.emit(this.internalRows);
  }

  delete(i: number) {
    this.internalRows.splice(i, 1);
    this.rows.emit(this.internalRows);
  }
}
